import { IconsProps } from './IconsProps';

const GoogleLogo = ({
  className = '',
  viewBox = '0 0 96 36',
  width = 96,
  height = 36,
  onClick,
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path
        d="M41.1048 20.8352C41.1048 25.4114 37.5597 28.7836 33.2089 28.7836C28.8582 28.7836 25.313 25.4114 25.313 20.8352C25.313 16.2266 28.8582 12.8867 33.2089 12.8867C37.5597 12.8867 41.1048 16.2266 41.1048 20.8352ZM37.6484 20.8352C37.6484 17.9754 35.5937 16.0188 33.2089 16.0188C30.8242 16.0188 28.7695 17.9754 28.7695 20.8352C28.7695 23.6662 30.8242 25.6515 33.2089 25.6515C35.5937 25.6515 37.6484 23.6626 37.6484 20.8352Z"
        fill="#EA4335"
      />
      <path
        d="M58.1387 20.8352C58.1387 25.4114 54.5936 28.7836 50.2428 28.7836C45.8921 28.7836 42.3469 25.4114 42.3469 20.8352C42.3469 16.2302 45.8921 12.8867 50.2428 12.8867C54.5936 12.8867 58.1387 16.2266 58.1387 20.8352ZM54.6823 20.8352C54.6823 17.9754 52.6276 16.0188 50.2428 16.0188C47.8581 16.0188 45.8034 17.9754 45.8034 20.8352C45.8034 23.6662 47.8581 25.6515 50.2428 25.6515C52.6276 25.6515 54.6823 23.6626 54.6823 20.8352Z"
        fill="#FBBC05"
      />
      <path
        d="M74.463 13.3669V27.6369C74.463 33.5068 71.0349 35.9043 66.9823 35.9043C63.1674 35.9043 60.8713 33.3276 60.0055 31.2205L63.0148 29.9555C63.5506 31.2491 64.8637 32.7758 66.9787 32.7758C69.5728 32.7758 71.1804 31.1596 71.1804 28.1171V26.9739H71.0597C70.2861 27.9379 68.7957 28.78 66.9148 28.78C62.9793 28.78 59.3738 25.3183 59.3738 20.8638C59.3738 16.3772 62.9793 12.8867 66.9148 12.8867C68.7921 12.8867 70.2826 13.7289 71.0597 14.6642H71.1804V13.3705H74.463V13.3669ZM71.4253 20.8638C71.4253 18.065 69.5764 16.0188 67.2236 16.0188C64.8388 16.0188 62.8409 18.065 62.8409 20.8638C62.8409 23.634 64.8388 25.6515 67.2236 25.6515C69.5764 25.6515 71.4253 23.634 71.4253 20.8638Z"
        fill="#4285F4"
      />
      <path
        d="M79.8747 5.00244V28.2959H76.5034V5.00244H79.8747Z"
        fill="#34A853"
      />
      <path
        d="M93.0122 23.4509L95.6951 25.257C94.8292 26.5507 92.7425 28.7797 89.137 28.7797C84.6656 28.7797 81.3262 25.2893 81.3262 20.8313C81.3262 16.1045 84.6939 12.8828 88.7502 12.8828C92.8348 12.8828 94.8327 16.1654 95.4857 17.9393L95.8441 18.8424L85.3221 23.243C86.1276 24.8377 87.3804 25.6512 89.137 25.6512C90.8972 25.6512 92.1179 24.7768 93.0122 23.4509ZM84.7543 20.5912L91.7879 17.6418C91.4011 16.6492 90.2371 15.9576 88.8673 15.9576C87.1106 15.9576 84.6656 17.5236 84.7543 20.5912Z"
        fill="#EA4335"
      />
      <path
        d="M12.5517 18.767V15.3948H23.8047C23.9147 15.9825 23.9715 16.6778 23.9715 17.4303C23.9715 19.9604 23.2866 23.0889 21.0793 25.3179C18.9323 27.5755 16.1892 28.7796 12.5553 28.7796C5.81978 28.7796 0.156006 23.2394 0.156006 16.4377C0.156006 9.63597 5.81978 4.0957 12.5553 4.0957C16.2814 4.0957 18.9359 5.57215 20.9303 7.49655L18.5739 9.87607C17.1438 8.52146 15.2062 7.46788 12.5517 7.46788C7.63318 7.46788 3.78635 11.4708 3.78635 16.4377C3.78635 21.4046 7.63318 25.4074 12.5517 25.4074C15.742 25.4074 17.559 24.1138 18.723 22.9383C19.6669 21.9851 20.2879 20.6233 20.5328 18.7634L12.5517 18.767Z"
        fill="#4285F4"
      />
    </svg>
  );
};

export default GoogleLogo;
